import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminDigest = () => {
  const [sending, setSending] = useState(false);

  const sendNow = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/admin/digest/send-now`, {}, { withCredentials: true });
      toast.success("Digest sent to owengraham5546@gmail.com.");
    } catch {
      toast.error("Could not send the digest.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-6" data-testid="admin-digest-card">
      <div>
        <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400 flex items-center gap-2">
          <MailCheck className="h-4 w-4" /> Daily Lead Digest
        </p>
        <p className="mt-3 text-sm text-slate-400 max-w-md">
          Every morning at 8:00 AM ET you get one email with yesterday's call requests, chat activity, new signups, and payments.
        </p>
      </div>
      <button
        onClick={sendNow} disabled={sending} data-testid="digest-send-now-button"
        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-semibold text-slate-200 transition-colors duration-300 hover:bg-white hover:text-[#060D1A] disabled:opacity-50"
      >
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <MailCheck className="h-4 w-4" />}
        Send Yesterday's Digest Now
      </button>
    </div>
  );
};
